import moment from "moment-timezone";
import {ISO_8601} from "./Formatters";

export const V1DocumentRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfDocumentRevision"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfDocumentRevision"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfDocumentRevision"].Count;
        }

        let results = [];

        if ("DocumentRevision" in input["ShifamedMessage"]["ListOfDocumentRevision"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfDocumentRevision"]["DocumentRevision"].length; i++) {
                let documentRevision = input["ShifamedMessage"]["ListOfDocumentRevision"]["DocumentRevision"][i];

                let row: any = {};

                row.USID = documentRevision.USID;
                row.DocumentUSID = documentRevision.DocumentUSID;
                row.DocumentID = documentRevision.DocumentID;
                row.DocumentIDPlusRevision = documentRevision.DocumentIDPlusRevision;
                row.DocumentTypeUSID = documentRevision.DocumentTypeUSID;
                row.DocumentTypeGroup = documentRevision.DocumentTypeGroup;
                row.DocumentTypeAcronym = documentRevision.DocumentTypeAcronm;
                row.Version = documentRevision.Version;
                row.Description = documentRevision.Description;
                row.Name = documentRevision.Name;
                row.Status = documentRevision.Status;
                row.DisplayStatus = documentRevision.DisplayStatus;
                row.ParentEquipmentUSID = documentRevision.ParentEquipmentUSID;
                row.Revision = documentRevision.Revision;
                row.RevisionStage = documentRevision.RevisionStage;
                row.OwnerUSID = documentRevision.OwnerUSID;
                row.OwnerUserUSID = documentRevision.OwnerUserUSID;
                row.OwnerUserName = documentRevision.OwnerUserName;
                row.ApprovalRequestUSID = documentRevision.ApprovalRequestUSID;
                row.ApprovalRequestID = documentRevision.ApprovalRequestID;
                row.RevisionChangeType = documentRevision.RevisionChangeType;
                row.DeprecatedAt = documentRevision.DeprecatedAt;
                row.ReleasedAt = documentRevision.ReleasedAt;
                row.ObsoletedAt = documentRevision.ObsoletedAt;
                row.Retrain = documentRevision.Retrain;
                row.EnlilFormInput = documentRevision.EnlilFormInput;
                row.FormDocumentRevisionUSID = documentRevision.FormDocumentRevisionUSID;
                row.ExternalID = documentRevision.ExternalID;
                row.RenderHTML = documentRevision.RenderHTML;
                row.PDFUSID = documentRevision.PDFUSID;
                row.SubRevision = documentRevision.SubRevision;
                row.DisplayRevision = documentRevision.DisplayRevision;
                row.PreCalc = documentRevision.PreCalc;
                row.Schema = documentRevision.Schema;
                row.EquipmentStatus = documentRevision.EquipmentStatus;
                row.PurchaseOrderStatus = documentRevision.PurchaseOrderStatus;
                row.LotStatus = documentRevision.LotStatus;
                row.EffectiveDate = documentRevision.EffectiveDate;
                row.PrimaryAttachmentUSID = documentRevision.PrimaryAttachmentUSID;
                row.LastZipFileUpdate = documentRevision.LastZipFileUpdate;
                row.ApprovedAt = documentRevision.ApprovedAt;
                row.SearchableContent = documentRevision.SearchableContent;
                row.CreatedDatetime = documentRevision.CreatedDatetime;
                row.LastModifiedDatetime = documentRevision.LastModifiedDatetime;
                row.Keyword = documentRevision.Keyword;
                row.Realm = documentRevision.CompanyUSID;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DocumentTypeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfDocumentType"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfDocumentType"].Count;
        }

        let results = [];

        if ("DocumentType" in input["ShifamedMessage"]["ListOfDocumentType"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input["ShifamedMessage"]["ListOfDocumentType"]["DocumentType"][i];

                let row: any = {};

                row.USID = documentType.USID;
                row.DocumentTypeName = documentType.DocumentTypeName;
                row.DocumentTypeAcronym = documentType.DocumentTypeAcronym;
                row.ListOfFormTemplate = documentType.ListOfFormTemplate;
                row.Group = documentType.Group;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DocumentTypeFormIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfDocumentType"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfDocumentType"].Count;
        }

        let results = [];

        if ("DocumentType" in input["ShifamedMessage"]["ListOfDocumentType"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input["ShifamedMessage"]["ListOfDocumentType"]["DocumentType"][i];

                let row: any = {};

                row.USID = documentType.USID;
                row.DocumentTypeName = documentType.DocumentTypeName;
                row.DocumentTypeAcronym = documentType.DocumentTypeAcronym;
                row.ListOfFormTemplate = documentType.ListOfFormTemplate;
                row.Group = documentType.Group;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ETLS3ConfigurationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfETLS3Configuration"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLS3Configuration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLS3Configuration"].Count;
        }

        let results = [];

        if ("ETLS3Configuration" in input["ShifamedMessage"]["ListOfETLS3Configuration"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLS3Configuration"]["ETLS3Configuration"].length; i++) {
                let etlS3Configuration = input["ShifamedMessage"]["ListOfETLS3Configuration"]["ETLS3Configuration"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = etlS3Configuration.USID;
                row.Name = etlS3Configuration.Name;
                row.AWSAccessKeyID = etlS3Configuration.AWSAccessKeyID;
                row.AWSSecretAccessKey = etlS3Configuration.AWSSecretAccessKey;
                row.AWSRegion = etlS3Configuration.AWSRegion;
                row.Bucket = etlS3Configuration.Bucket;
                row.Path = etlS3Configuration.Path;
                row.CreatedDatetime = etlS3Configuration.CreatedDatetime;
                row.LastModifiedDatetime = etlS3Configuration.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ETLGoogleConfigurationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfETLGoogleConfiguration"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLGoogleConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLGoogleConfiguration"].Count;
        }

        let results = [];

        if ("ETLGoogleConfiguration" in input["ShifamedMessage"]["ListOfETLGoogleConfiguration"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLGoogleConfiguration"]["ETLGoogleConfiguration"].length; i++) {
                let etlGoogleConfiguration = input["ShifamedMessage"]["ListOfETLGoogleConfiguration"]["ETLGoogleConfiguration"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = etlGoogleConfiguration.USID;
                row.Name = etlGoogleConfiguration.Name;
                row.ServiceAccountEmail = etlGoogleConfiguration.ServiceAccountEmail;
                row.ProjectID = etlGoogleConfiguration.ProjectID;
                row.PrivateKey = etlGoogleConfiguration.PrivateKey;
                row.Path = etlGoogleConfiguration.Path;
                row.CreatedDatetime = etlGoogleConfiguration.CreatedDatetime;
                row.LastModifiedDatetime = etlGoogleConfiguration.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ETLGoogleConfigurationDetailIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfObject"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfObject"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfObject"].Count;
        }

        let results = [];

        if ("Object" in input["ShifamedMessage"]["ListOfObject"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfObject"]["Object"].length; i++) {
                let object = input["ShifamedMessage"]["ListOfObject"]["Object"][i];

                let row: any = {};

                row.RowSelected = false;
                row.ID = object.ID;
                row.Name = object.Name;
                row.MimeType = object.MimeType;
                row.Version = object.Version;
                row.Size = object.Size;
                row.ListOfChildObject = object.ListOfChildObject;
                row.CreatedTime = object.CreatedTime;
                row.ModifiedTime = object.ModifiedTime;

                if (row.ListOfChildObject.ChildObject.length !== 0) {
                    row.path = row.Name
                    calculatePath(results, row, row.Name)
                }

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

const calculatePath = (results: any[], row: any, path?: string | undefined) => {
    for (let i = 0; i < row.ListOfChildObject.ChildObject.length; i++) {
        row.ListOfChildObject.ChildObject[i].path = path + "/" + row.ListOfChildObject.ChildObject[i].Name;
        results.push(row.ListOfChildObject.ChildObject[i]);

        calculatePath(results, row.ListOfChildObject.ChildObject[i], path + "/" + row.ListOfChildObject.ChildObject[i].Name);
    }
};

export const V1ETLJobIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfETLJob"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLJob"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLJob"].Count;
        }

        let results = [];

        if ("ETLJob" in input["ShifamedMessage"]["ListOfETLJob"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLJob"]["ETLJob"].length; i++) {
                let etlJob = input["ShifamedMessage"]["ListOfETLJob"]["ETLJob"][i];

                let row: any = {};

                let unordered = JSON.parse(atob(etlJob.Specification));
                const ordered = Object.keys(unordered).sort().reduce(
                    (obj: any, key: string) => {
                        obj[key] = unordered[key];
                        return obj;
                    },
                    {}
                );

                row.RowSelected = false;
                row.USID = etlJob.USID;
                row.Name = etlJob.Name;
                row.OwnerUSID = etlJob.OwnerUSID;
                row.UserUSID = etlJob.UserUSID;
                row.OwnerName = etlJob.OwnerName;
                row.OwnerEmail = etlJob.OwnerEmail;
                row.Type = etlJob.Type;
                row.SubType = etlJob.SubType;
                row.Specification = ordered;
                row.Status = etlJob.Status;
                row.NumberOfRunningExecutions = etlJob.NumberOfRunningExecutions;
                row.NumberOfSucceededExecutions = etlJob.NumberOfSucceededExecutions;
                row.NumberOfFailedExecutions = etlJob.NumberOfFailedExecutions;
                row.CreatedDatetime = etlJob.CreatedDatetime;
                row.LastModifiedDatetime = etlJob.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ETLJobExecutionIDOCToArray = (input: any) => {
    let output: any = {};

    let results = [];

    if (input["ShifamedMessage"]["ListOfETLJobExecution"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLJobExecution"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLJobExecution"].Count;
        }

        if ("ETLJobExecution" in input["ShifamedMessage"]["ListOfETLJobExecution"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLJobExecution"]["ETLJobExecution"].length; i++) {
                let etlJobExecution = input["ShifamedMessage"]["ListOfETLJobExecution"]["ETLJobExecution"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = etlJobExecution.USID;
                row.ETLJobUSID = etlJobExecution.ETLJobUSID;
                row.ETLJobName = etlJobExecution.ETLJobName;
                let AWSBatchJobInfo = JSON.parse(atob(etlJobExecution.AWSBatchJobInfo));
                row.Status = null;
                if (AWSBatchJobInfo.length > 0) {
                    row.Status = AWSBatchJobInfo[0].status;
                }
                row.StatusReason = null;
                if (AWSBatchJobInfo.length > 0) {
                    row.StatusReason = AWSBatchJobInfo[0].statusReason;
                }
                row.StartedDatetime = null;
                if (AWSBatchJobInfo.length > 0 && AWSBatchJobInfo[0].startedAt) {
                    row.StartedDatetime = moment.utc(moment.unix(AWSBatchJobInfo[0].startedAt / 1000)).format(ISO_8601);
                }
                row.StoppedDatetime = null;
                if (AWSBatchJobInfo.length > 0 && AWSBatchJobInfo[0].stoppedAt) {
                    row.StoppedDatetime = moment.utc(moment.unix(AWSBatchJobInfo[0].stoppedAt/1000)).format(ISO_8601);
                }
                row.CreatedDatetime = etlJobExecution.CreatedDatetime;
                row.LastModifiedDatetime = etlJobExecution.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    } else if (input["ShifamedMessage"]["Count"] !== undefined) {
        output["Count"] = input["ShifamedMessage"].Count;
        let row: any = {};

        row.Counter = output["Count"];

        row["__operation"] = "query results";

        results.push(row);

        output["Results"] = results;
    }

    return output;
};

export const V1ETLJobPreExecutionLogIDOCToArray = (input: any) => {
    let output: any = {};

    let results = [];

    if (input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"].Count;
        }

        if ("ETLJobPreExecutionLog" in input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"]["ETLJobPreExecutionLog"].length; i++) {
                let etlJobPreExecutionLog = input["ShifamedMessage"]["ListOfETLJobPreExecutionLog"]["ETLJobPreExecutionLog"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = etlJobPreExecutionLog.USID;
                row.ETLJobExecutionUSID = etlJobPreExecutionLog.ETLJobExecutionUSID;
                row.Log = etlJobPreExecutionLog.Log;
                row.LogJSON = JSON.parse(atob(etlJobPreExecutionLog.Log));
                row.CreatedDatetime = etlJobPreExecutionLog.CreatedDatetime;
                row.LastModifiedDatetime = etlJobPreExecutionLog.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ETLJobExecutionLogIDOCToArray = (input: any) => {
    let output: any = {};

    let results = [];

    if (input["ShifamedMessage"]["ListOfETLJobExecutionLog"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLJobExecutionLog"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLJobExecutionLog"].Count;
        }

        if ("ETLJobExecutionLog" in input["ShifamedMessage"]["ListOfETLJobExecutionLog"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLJobExecutionLog"]["ETLJobExecutionLog"].length; i++) {
                let etlJobExecutionLog = input["ShifamedMessage"]["ListOfETLJobExecutionLog"]["ETLJobExecutionLog"][i];

                let row: any = {};

                row.CreatedDatetime = etlJobExecutionLog.CreatedDatetime;
                row.Log = etlJobExecutionLog.Log;

                row.LogJSON = JSON.parse(atob(row.Log));

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ETLJobSystemExecutionLogIDOCToArray = (input: any) => {
    let output: any = {};

    let results = [];

    if (input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"].Count;
        }

        if ("ETLJobSystemExecutionLog" in input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"]["ETLJobSystemExecutionLog"].length; i++) {
                let etlJobSystemExecutionLog = input["ShifamedMessage"]["ListOfETLJobSystemExecutionLog"]["ETLJobSystemExecutionLog"][i];

                let row: any = {};

                row.Log = etlJobSystemExecutionLog.Log;

                row.LogJSON = JSON.parse(atob(row.Log));

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfEmployee"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfEmployee"].Count;
        }

        let results = [];

        if ("Employee" in input["ShifamedMessage"]["ListOfEmployee"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input["ShifamedMessage"]["ListOfEmployee"]["Employee"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = employee.USID;
                row.UserUSID = employee.UserUSID;
                row.Email = employee.Email;
                row.UserName = employee.UserName;
                row.Confirmed = employee.Confirmed;
                row.Locked = employee.Locked;
                row.Active = employee.Active;
                row.SlackUserID = employee.SlackUserID;
                row.CreatedDatetime = employee.CreatedDatetime;
                row.LastModifiedDatetime = employee.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfAdminPositionMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminPositionMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminPositionMembership"].Count;
        }

        let results = [];

        if ("AdminPositionMembership" in input["ShifamedMessage"]["ListOfAdminPositionMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminPositionMembership"]["AdminPositionMembership"].length; i++) {
                let adminPositionMembership = input["ShifamedMessage"]["ListOfAdminPositionMembership"]["AdminPositionMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminPositionMembership.USID;
                row.SourceUSID = adminPositionMembership.SourceUSID;
                row.SourceType = adminPositionMembership.SourceType;
                row.PositionUSID = adminPositionMembership.PositionUSID;
                row.PositionName = adminPositionMembership.PositionName;
                row.PrimaryEmployeeUSID = adminPositionMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminPositionMembership.PrimaryEmployeeName;
                row.Employees = adminPositionMembership.AdminPosition.ListOfEmployee.Employee;
                row.Realm = adminPositionMembership.Realm;
                row.CreatedDatetime = adminPositionMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminPositionMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfAdminUserGroupMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminUserGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminUserGroupMembership"].Count;
        }

        let results = [];

        if ("AdminUserGroupMembership" in input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]["AdminUserGroupMembership"].length; i++) {
                let adminUserGroupMembership = input["ShifamedMessage"]["ListOfAdminUserGroupMembership"]["AdminUserGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminUserGroupMembership.USID;
                row.SourceUSID = adminUserGroupMembership.SourceUSID;
                row.SourceType = adminUserGroupMembership.SourceType;
                row.UserGroupUSID = adminUserGroupMembership.UserGroupUSID;
                row.UserGroupName = adminUserGroupMembership.UserGroupName;
                row.PrimaryEmployeeUSID = adminUserGroupMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminUserGroupMembership.PrimaryEmployeeName;
                row.Employees = adminUserGroupMembership.ListOfEmployee.Employee;
                row.Realm = adminUserGroupMembership.Realm;
                row.CreatedDatetime = adminUserGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminUserGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"] !== undefined) {
        if (input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"].Count;
        }

        let results = [];

        if ("AdminWorkGroupMembership" in input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]) {
            for (let i = 0; i < input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]["AdminWorkGroupMembership"].length; i++) {
                let adminWorkGroupMembership = input["ShifamedMessage"]["ListOfAdminWorkGroupMembership"]["AdminWorkGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminWorkGroupMembership.USID;
                row.SourceUSID = adminWorkGroupMembership.SourceUSID;
                row.SourceType = adminWorkGroupMembership.SourceType;
                row.AdminWorkGroup = adminWorkGroupMembership.AdminWorkGroup;
                row.WorkGroupUSID = adminWorkGroupMembership.WorkGroupUSID;
                row.WorkGroupName = adminWorkGroupMembership.WorkGroupName;
                row.PrimaryEmployeeUSID = adminWorkGroupMembership.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = adminWorkGroupMembership.PrimaryEmployeeName;
                row.Realm = adminWorkGroupMembership.Realm;
                row.CreatedDatetime = adminWorkGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminWorkGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1AdminOrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminOrganization"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminOrganization"].Count;
        }

        let results: any[] = [];

        if ("AdminOrganization" in input.ShifamedMessage["ListOfAdminOrganization"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"].length; i++) {
                let organization = input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = organization.USID;
                row.ParentUSID = organization.ParentUSID;
                row.ParentOrganizationName = organization.ParentOrganizationName;
                row.OrganizationType = organization.OrganizationType;
                row.Name = organization.Name;
                row.Status = organization.Status;

                row.CreatedDatetime = organization.CreatedDatetime;
                row.LastModifiedDatetime = organization.LastModifiedDatetime;
                row.Keyword = organization.Keyword;
                row.Realm = organization.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }

    return output;
};

export const V1AdminOrganizationPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminOrganization"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminOrganization"].Count;
        }

        let results: any[] = [];

        if ("AdminOrganization" in input.ShifamedMessage["ListOfAdminOrganization"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"].length; i++) {
                let organization = input.ShifamedMessage["ListOfAdminOrganization"]["AdminOrganization"][i];

                for (let j = 0; j < organization["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = organization["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;
                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (organization["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = organization["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminPosition"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPosition"].Count;
        }

        let results: any[] = [];

        if ("AdminPosition" in input.ShifamedMessage["ListOfAdminPosition"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"].length; i++) {
                let position = input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = position.USID;
                row.ParentUSID = position.ParentUSID;
                row.ParentPositionName = position.ParentPositionName;
                row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                row.OrganizationUSID = position.OrganizationUSID;
                row.OrganizationName = position.OrganizationName;
                row.Name = position.Name;
                row.Status = position.Status;

                row.CreatedDatetime = position.CreatedDatetime;
                row.LastModifiedDatetime = position.LastModifiedDatetime;
                row.Keyword = position.Keyword;
                row.Realm = position.Realm;

                row.ListOfEmployee = {
                    Employee: []
                };

                if ("ListOfEmployee" in position) {
                    for (let j = 0; j < position["ListOfEmployee"]["Employee"].length; j++) {
                        let employee: any = position["ListOfEmployee"]["Employee"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.UserName = employee.UserName;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.SlackUserID = employee.SlackUserID;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfEmployee.Employee.push(employee_row);
                    }
                }
                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPositionEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminPosition"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPosition"].Count;
        }

        let results: any[] = [];

        if ("AdminPosition" in input.ShifamedMessage["ListOfAdminPosition"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"].length; i++) {
                let position = input.ShifamedMessage["ListOfAdminPosition"]["AdminPosition"][i];

                for (let j = 0; j < position["ListOfEmployee"]["Employee"].length; j++) {
                    let employee: any = position["ListOfEmployee"]["Employee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (position["ListOfEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = position["ListOfEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminRoleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminRole"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminRole"].Count;
        }

        let results: any[] = [];

        if ("AdminRole" in input.ShifamedMessage["ListOfAdminRole"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminRole"]["AdminRole"].length; i++) {
                let role = input.ShifamedMessage["ListOfAdminRole"]["AdminRole"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = role.USID;
                row.ParentRoleUSID = role.ParentRoleUSID;
                row.ParentRoleName = role.ParentRoleName;
                row.Name = role.Name;
                row.Status = role.Status;

                row.CreatedDatetime = role.CreatedDatetime;
                row.LastModifiedDatetime = role.LastModifiedDatetime;
                row.Keyword = role.Keyword;
                row.Realm = role.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminRoleChildIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminRole"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminRole"].Count;
        }

        let results: any[] = [];

        if ("AdminRole" in input.ShifamedMessage["ListOfAdminRole"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminRole"]["AdminRole"].length; i++) {
                let role = input.ShifamedMessage["ListOfAdminRole"]["AdminRole"][i];

                for (let j = 0; j < role["ListOfAdminRoleChild"]["AdminRoleChild"].length; j++) {
                    let child: any = role["ListOfAdminRoleChild"]["AdminRoleChild"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = child.USID;
                    row.Name = child.Name;
                    row.Status = child.Status;

                    row.CreatedDatetime = child.CreatedDatetime;
                    row.LastModifiedDatetime = child.LastModifiedDatetime;
                    row.Keyword = child.Keyword;
                    row.Realm = child.Realm;

                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (role["ListOfAdminRoleChild"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = role["ListOfAdminRoleChild"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminPrivilegeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminPrivilege"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminPrivilege"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminPrivilege"].Count;
        }

        let results: any[] = [];

        if ("AdminPrivilege" in input.ShifamedMessage["ListOfAdminPrivilege"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminPrivilege"]["AdminPrivilege"].length; i++) {
                let privilege = input.ShifamedMessage["ListOfAdminPrivilege"]["AdminPrivilege"][i];

                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = privilege.USID;
                row.Name = privilege.Name;

                row.ListOfAdminRole = privilege.ListOfAdminRole;
                row.CreatedDatetime = privilege.CreatedDatetime;
                row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                row.Keyword = privilege.Keyword;
                row.Realm = privilege.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminRoleEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminRole"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminRole"].Count;
        }

        let results: any[] = [];

        if ("AdminRole" in input.ShifamedMessage["ListOfAdminRole"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminRole"]["AdminRole"].length; i++) {
                let role = input.ShifamedMessage["ListOfAdminRole"]["AdminRole"][i];

                for (let j = 0; j < role["ListOfEmployee"]["Employee"].length; j++) {
                    let employee: any = role["ListOfEmployee"]["Employee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (role["ListOfEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = role["ListOfEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminRolePrivilegeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminRole"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminRole"].Count;
        }

        let results: any[] = [];

        if ("AdminRole" in input.ShifamedMessage["ListOfAdminRole"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminRole"]["AdminRole"].length; i++) {
                let role = input.ShifamedMessage["ListOfAdminRole"]["AdminRole"][i];

                for (let j = 0; j < role["ListOfAdminPrivilege"]["AdminPrivilege"].length; j++) {
                    let privilege: any = role["ListOfAdminPrivilege"]["AdminPrivilege"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = privilege.USID;
                    row.RoleUSID = role.USID;
                    row.Realm = role.Realm;
                    row.Name = privilege.Name;
                    row.CreatedDatetime = privilege.CreatedDatetime;
                    row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (role["ListOfAdminPrivilege"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = role["ListOfAdminPrivilege"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminUserGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminUserGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminUserGroup" in input.ShifamedMessage["ListOfAdminUserGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"].length; i++) {
                let user_group = input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = user_group.USID;
                row.PrimaryEmployeeUSID = user_group.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = user_group.PrimaryEmployeeName;
                row.Name = user_group.Name;
                row.Status = user_group.Status;

                row.CreatedDatetime = user_group.CreatedDatetime;
                row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                row.Keyword = user_group.Keyword;
                row.Realm = user_group.Realm;

                row.ListOfEmployee = {
                    Employee: []
                };

                if ("ListOfEmployee" in user_group) {
                    for (let j = 0; j < user_group["ListOfEmployee"]["Employee"].length; j++) {
                        let employee: any = user_group["ListOfEmployee"]["Employee"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.UserName = employee.UserName;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.SlackUserID = employee.SlackUserID;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfEmployee.Employee.push(employee_row);
                    }
                }

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminUserGroupEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminUserGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminUserGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminUserGroup" in input.ShifamedMessage["ListOfAdminUserGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"].length; i++) {
                let user_group = input.ShifamedMessage["ListOfAdminUserGroup"]["AdminUserGroup"][i];

                for (let j = 0; j < user_group["ListOfEmployee"]["Employee"].length; j++) {
                    let employee: any = user_group["ListOfEmployee"]["Employee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (user_group["ListOfEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = user_group["ListOfEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = work_group.USID;
                row.PrimaryEmployeeUSID = work_group.PrimaryEmployeeUSID;
                row.PrimaryEmployeeName = work_group.PrimaryEmployeeName;
                row.Name = work_group.Name;
                row.Status = work_group.Status;

                row.CreatedDatetime = work_group.CreatedDatetime;
                row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                row.Keyword = work_group.Keyword;
                row.Realm = work_group.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfWorkGroupEmployee"]["WorkGroupEmployee"].length; j++) {
                    let employee: any = work_group["ListOfWorkGroupEmployee"]["WorkGroupEmployee"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = employee.USID;
                    row.UserUSID = employee.UserUSID;
                    row.Email = employee.Email;
                    row.UserName = employee.UserName;
                    row.Confirmed = employee.Confirmed;
                    row.Locked = employee.Locked;
                    row.Active = employee.Active;
                    row.SlackUserID = employee.SlackUserID;
                    row.CreatedDatetime = employee.CreatedDatetime;
                    row.LastModifiedDatetime = employee.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfWorkGroupEmployee"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfWorkGroupEmployee"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupOrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminOrganization"]["AdminOrganization"].length; j++) {
                    let organization: any = work_group["ListOfAdminOrganization"]["AdminOrganization"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = organization.USID;
                    row.Realm = organization.Realm;
                    row.ParentUSID = organization.ParentUSID;
                    row.ParentOrganizationName = organization.ParentOrganizationName;
                    row.OrganizationType = organization.OrganizationType;
                    row.Name = organization.Name;
                    row.CreatedDatetime = organization.CreatedDatetime;
                    row.LastModifiedDatetime = organization.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminOrganization"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminOrganization"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = work_group["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.Realm = position.Realm;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryEmployeeUSID = position.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = position.PrimaryEmployeeName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AdminWorkGroupUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfAdminWorkGroup"] !== undefined) {
        if (input.ShifamedMessage["ListOfAdminWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfAdminWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("AdminWorkGroup" in input.ShifamedMessage["ListOfAdminWorkGroup"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; i++) {
                let work_group = input.ShifamedMessage["ListOfAdminWorkGroup"]["AdminWorkGroup"][i];

                for (let j = 0; j < work_group["ListOfAdminUserGroup"]["AdminUserGroup"].length; j++) {
                    let userGroup: any = work_group["ListOfAdminUserGroup"]["AdminUserGroup"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = userGroup.USID;
                    row.Realm = userGroup.Realm;
                    row.PrimaryEmployeeUSID = userGroup.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = userGroup.PrimaryEmployeeName;
                    row.Name = userGroup.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfAdminUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfAdminUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminRoleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminRole"]["AdminRole"].length; j++) {
                    let role: any = employee["ListOfAdminRole"]["AdminRole"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = role.USID;
                    row.ParentRoleUSID = role.ParentRoleUSID;
                    row.ParentRoleName = role.ParentRoleName;
                    row.Name = role.Name;
                    row.Status = role.Status;

                    row.CreatedDatetime = role.CreatedDatetime;
                    row.LastModifiedDatetime = role.LastModifiedDatetime;
                    row.Keyword = role.Keyword;
                    row.Realm = role.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminRole"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminRole"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminPosition"]["AdminPosition"].length; j++) {
                    let position: any = employee["ListOfAdminPosition"]["AdminPosition"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.Name = position.Name;
                    row.Status = position.Status;

                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Keyword = position.Keyword;
                    row.Realm = position.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminUserGroup"]["AdminUserGroup"].length; j++) {
                    let user_group: any = employee["ListOfAdminUserGroup"]["AdminUserGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = user_group.USID;
                    row.PrimaryEmployeeUSID = user_group.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = user_group.PrimaryEmployeeName;
                    row.Name = user_group.Name;
                    row.Status = user_group.Status;

                    row.CreatedDatetime = user_group.CreatedDatetime;
                    row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                    row.Keyword = user_group.Keyword;
                    row.Realm = user_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1EmployeeAdminWorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.ShifamedMessage["ListOfEmployee"] !== undefined) {
        if (input.ShifamedMessage["ListOfEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.ShifamedMessage["ListOfEmployee"].Count;
        }

        let results: any[] = [];

        if ("Employee" in input.ShifamedMessage["ListOfEmployee"]) {
            for (let i = 0; i < input.ShifamedMessage["ListOfEmployee"]["Employee"].length; i++) {
                let employee = input.ShifamedMessage["ListOfEmployee"]["Employee"][i];

                for (let j = 0; j < employee["ListOfAdminWorkGroup"]["AdminWorkGroup"].length; j++) {
                    let work_group: any = employee["ListOfAdminWorkGroup"]["AdminWorkGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = work_group.USID;
                    row.PrimaryEmployeeUSID = work_group.PrimaryEmployeeUSID;
                    row.PrimaryEmployeeName = work_group.PrimaryEmployeeName;
                    row.Name = work_group.Name;
                    row.Status = work_group.Status;

                    row.CreatedDatetime = work_group.CreatedDatetime;
                    row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                    row.Keyword = work_group.Keyword;
                    row.Realm = work_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfAdminWorkGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfAdminWorkGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};
